import React, { useEffect, useMemo, useState } from "react";
import "./RupturasDoDiaPrint.css";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";

export default function RupturasDoDiaPrint({ dados, dataInicial, dataFinal }) {
  const [dadosFormatados, setDadosFormatados] = useState([]);

  useEffect(() => {
    function montarDados() {
      const listaTemp = [];

      for (const item of dados || []) {
        if (!item?.id) continue;

        (item.codigos || []).forEach((codigoCaminhao, indiceCodigo) => {
          listaTemp.push({
            ...item,
            cod_caminhao: Number(codigoCaminhao) || 0,
            moduloElasticidade: item.modulosElasticidade?.[indiceCodigo] === true,
            codigoExibicao: item.origem === "dosagem" && item.codigoDosagem
              ? `T${item.codigoDosagem}`
              : ""
          });
        });
      }

      listaTemp.sort((a, b) => {
        if (a.obra < b.obra) return -1;
        if (a.obra > b.obra) return 1;
        if (a.dataRuptura < b.dataRuptura) return -1;
        if (a.dataRuptura > b.dataRuptura) return 1;
        if (a.dataMoldagem < b.dataMoldagem) return -1;
        if (a.dataMoldagem > b.dataMoldagem) return 1;
        if (Number(a.idade) < Number(b.idade)) return -1;
        if (Number(a.idade) > Number(b.idade)) return 1;
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;
        return Number(a.cod_caminhao) - Number(b.cod_caminhao);
      });

      const listaFinal = [];
      let contador = 0;
      let chaveGrupoAtual = "";
      let moldagemAnterior = "";

      listaTemp.forEach(item => {
        const chaveGrupo = [
          item.obra,
          item.dataRuptura,
          item.dataMoldagem,
          item.idade
        ].join("|");
        const novoGrupo = chaveGrupo !== chaveGrupoAtual;
        const novaMoldagem = item.id !== moldagemAnterior;

        if (novoGrupo) {
          contador = 1;
          chaveGrupoAtual = chaveGrupo;
        } else {
          contador++;
        }

        listaFinal.push({
          ...item,
          cod_caminhao: contador,
          codigoExibicao: item.codigoExibicao || contador,
          obra: novoGrupo || novaMoldagem ? item.obra : ""
        });
        moldagemAnterior = item.id;
      });

      setDadosFormatados(listaFinal);
    }

    if (Array.isArray(dados) && dados.length > 0) {
      montarDados();
    } else {
      setDadosFormatados([]);
    }
  }, [dados]);

  function formatarDataBR(dataISO) {
    if (!dataISO) return "";
    const [ano, mes, dia] = dataISO.split("-");
    return `${dia}/${mes}/${ano}`;
  }

  const paginas = useMemo(() => {
    const linhasFixas = 18;
    const listaPaginas = [];

    for (let i = 0; i < dadosFormatados.length; i += linhasFixas) {
      const pagina = dadosFormatados.slice(i, i + linhasFixas);
      while (pagina.length < linhasFixas) pagina.push(null);
      listaPaginas.push(pagina);
    }

    if (listaPaginas.length === 0) {
      listaPaginas.push(Array(linhasFixas).fill(null));
    }

    return listaPaginas;
  }, [dadosFormatados]);

  return (
    <div className="relatorio-print">
      <div className="print-container">
        {paginas.map((dadosPagina, paginaIndex) => (
          <div className="pagina" key={paginaIndex}>
            <table className="tabela">
              <tbody>
                <tr>
                  <td rowSpan="3" style={{ width: 140 }}>
                    <LogoRelatorio alt="Logo" className="logo"  />
                  </td>
                  <td colSpan="5" rowSpan="3" className="titulo">
                    SISTEMA DE GESTÃO DA QUALIDADE
                    <br />
                    Controle de rompimento - Corpos de Prova de concreto
                  </td>
                  <td className="center" style={{ width: 170 }}>RQ 2.2.2</td>
                </tr>
                <tr><td className="center">Revisão 00</td></tr>
                <tr><td className="center">20/08/2025</td></tr>
              </tbody>
            </table>

            <div className="periodo">
              <strong>PERÍODO DE RUPTURA:</strong>{" "}
              {formatarDataBR(dataInicial)} a {formatarDataBR(dataFinal)}
            </div>

            <table className="tabela tabela-principal">
              <thead>
                <tr>
                  <th className="col-data-moldagem">DATA MOLDAGEM</th>
                  <th className="col-cliente-obra">CLIENTE/OBRA</th>
                  <th className="col-codigo">CÓDIGO</th>
                  <th className="col-idade">IDADE CP</th>
                  <th className="col-carga">CARGA (tf)</th>
                  <th className="col-observacao">OBSERVAÇÃO</th>
                </tr>
              </thead>
              <tbody>
                {dadosPagina.map((item, index) => (
                  <tr key={index}>
                    <td>{item ? formatarDataBR(item.dataMoldagem) : ""}</td>
                    <td className="col-cliente-obra">
                      {item?.obra ? (
                        <>
                          <div>{item.cliente || ""}</div>
                          <div>{item.obra}</div>
                        </>
                      ) : ""}
                    </td>
                    <td>{item ? item.codigoExibicao : ""}</td>
                    <td>{item ? `${item.idade} dias` : ""}</td>
                    <td className="col-carga">
                      <div className="campo-carga"></div>
                      <div className="campo-carga"></div>
                    </td>
                    <td className="col-observacao">
                      {item &&
                      Number(String(item.idade).replace(",", ".")) === 28 &&
                      item.moduloElasticidade === true
                        ? "MÓDULO"
                        : ""}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <table className="bloco-final">
              <tbody>
                <tr>
                  <td className="bloco-final-executante">
                    <strong>EXECUTANTE:</strong>
                  </td>
                  <td className="bloco-final-prensa">
                    <strong>IDENTIFICAÇÃO DA PRENSA (nº certificado)</strong>
                  </td>
                  <td className="bloco-final-data">
                    <strong>DATA DO ENSAIO</strong>
                    <br />
                    {new Date().toLocaleDateString("pt-BR")}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
  );
}
